import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import Checkbox from "../../../../generic/checkbox";
import InputField from "../../../../generic/inputField";
import TocDropdown from "../../../../generic/tocDropdown";
import sampleSignature from "../../../../../assets/images/Sample-signature-image.png";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { IdentifDet } from "./identificationSection";
import {
  ageCalculator,
  applicantRelationships,
  NOMINEE,
  Titles,
  TYPE,
  NOMINEEERROR,
  Relationship,
  areaErrorString,
  AREAOPTIONSTATUS,
  identificationOptions,
  Required,
  getNestedValue,
  ValidationFields,
} from "./constant";
import { Address } from "./address";
import moment from "moment";
import {
  alphabetExp,
  alphaNumExpWithSpace,
  detectIntWithSpace,
  emailRegex,
  integerExp,
  phoneNo,
  specialCharExpression,
} from "../../../../utils/regex";
import { getArea, getFullAddress } from "../../../../service/generic/otherApi";
import { getAccData } from "../../../../service/login/loginService";
import EdModal from "../../../../generic/edModal";
interface Type {
  id: number;
  name: string;
  fieldName: string;
}

export const NomineeGuardianForm = forwardRef((props: any, ref: any) => {
  const [type, setType] = useState<Type>();
  const [nominee, setNominee] = useState<any>(
    props.type === 1 ? props.nominee[props.id] : props.nominee[props.id].guard
  );
  const [nomineeErr, setNomineeErr] = useState<any>(NOMINEEERROR);
  const [showPincodeErrorModel, setShowPincodeErrorModel] = useState(false);
  const [areaOptions, setAreaOptions] = useState<any>([AREAOPTIONSTATUS]);
  const [identity, setIdentity] = useState<any>();
  const [showOptional, setShowOptional] = useState<boolean>(false);
  const [viewSampleImage, setViewSampleImage] = useState(false);
  const childRef = useRef<any>();

  useEffect(() => {
    setNominee(
      props.type === 1 ? props.nominee[props.id] : props.nominee[props.id].guard
    );
  }, [props.nominee]);

  useEffect(() => {
    const Type = TYPE.find((t) => t.id === props.type);
    setType(Type);
  }, []);
  const validateForm = (val: any, type: any) => {
    switch (type) {
      case "firstName":
        let firstName = "";
        if (!val) firstName = "First Name is required";
        
        if (!alphabetExp.test(val)) firstName = "Only alphabets is allowed";
        return firstName;
      case "middleName":
        let middleName = "";
        
        if (!alphabetExp.test(val)) middleName = "Only alphabets is allowed";
        return middleName;

      case "lastName":
        let lastName = "";
        
        if (!alphabetExp.test(val)) lastName = "Only alphabets is allowed";
        return lastName;

      case "birthdate":
        let dob = "";
        if (!val) dob = "Date of birth is required";
        return dob;

      case "nomRel":
        let nomRel = "";
        if (!val) nomRel = "Nominee Relationship is required";

        return nomRel;
      case "title":
        let title = "";
        if (!val) title = "Required";

        return title;

      case "nomPer":
        let nomPer = "";
        if (!val) nomPer = "Nominee shares is required";
        if ((val && val <= 0) || !val)
          nomPer = "Nominee Shares Must greater than 0";
        if (val && val > 100)
          nomPer = "Nominee Shares Must less than or equal to 100";
        return nomPer;

      case "email":
        let email = "";
        // if (!email) email = "Email is required";
        if (!emailRegex.test(val) && val.length > 0)
          email = "Please enter a valid email id";
        return email;

      case "phone":
        let phone = "";
        // if () phone = "Mobile no. is required";
        if (!phoneNo.test(val) && val.length > 0)
          phone = "Please enter a valid phone number";
        return phone;
    }
  };
  function handleNomineeShares() {
    if (props.nominee.length > 0) {
      let getPercent = props.nominee.map((nom: any) =>
        nom.nomPer ? parseFloat(nom.nomPer) : 0
      );
      return getPercent.reduce(
        (prevPer: number, curPer: number) => prevPer + curPer
      );
    }
    return Number(0);
    //else {
    //   return value ? parseFloat(value) : 0;
    // }
  }
  const onChange = (value: any, field?: string) => {
    let deleteGuard: any;
    if (type?.id === 1 && value.birthdate) {
      const age = ageCalculator(value.birthdate);
      value.minor = age < 18 ? true : false;
      if (value.minor) {
        const guard: any = NOMINEE;
        delete guard.nomPer;
        const guardian = true;
        value.guard = { ...guard, guardian };
      } else {
        if (nominee.guard) {
          const { guard: tmp, ...rest } = nominee;
          deleteGuard = rest;
        }
      }
    }

    //reset guardian on uncheck of same as guardian checkbox
    if (!value.sameas && field === "sameAs") {
      const guard: any = NOMINEE;
      delete guard.nomPer;
      const guardian = true;
      value.guard = { ...guard, guardian };
    }
    //

    let nom = deleteGuard ? deleteGuard : nominee;
    setNominee({ ...nom, ...value });
    const key = Object.keys(value)[0];
    if (typeof nomineeErr[key] === "object" && field) {
      setNomineeErr({
        ...nomineeErr,
        [key]: { ...nomineeErr.address, [field]: "" },
      });
    } else {
      let err: any = {};
      Object.keys(value).map((x) => {
        err[x] = "";
      });
      setNomineeErr({ ...nomineeErr, ...err });
    }

    const totalNominee = JSON.parse(JSON.stringify(props.nominee));
    if (type?.id === 1) {
      totalNominee[props.id] = {
        ...nom,
        ...value,
      };
    } else {
      totalNominee[props.id].guard = {
        ...nom,
        ...value,
      };
    }
    props.updateNominee(totalNominee);
  };
  const addressErr = (val: any, type: string) => {
    let err = "";
    // console.log("type", type);

    if (type === "pin") {
      if (val.length !== 6) err = "Pincode must be 6 digit.";
    } else {
      if (!val && type === "addr1") err = "Address is required";
      if (val.length > 0 && integerExp.test(val))
        err = "All the characters can't be Number.";
      // if (val.length > 0 && error.value.length < 5)
      //   err = "Minimum 5 characters are required.";
      if (!alphaNumExpWithSpace.test(val))
        err = "Special characters are not allowed like < , > etc.";
    }
    return err;
  };
  useImperativeHandle(ref, () => ({
    validation() {
      let err: any = {};
      let validation = true;
      const required = JSON.parse(JSON.stringify(Required));
      const validationFields = JSON.parse(JSON.stringify(ValidationFields));

      if (props.type === 1) {
        required.push("nomPer");
      }
      if (identity) {
        if (
          identity === identificationOptions[1].value ||
          identity === identificationOptions[6].value
        ) {
          required.push("attachment.data");
        } else {
          required.push(identity);
        }
      }
      if (identity) {
        if (
          identity === identificationOptions[1].value ||
          identity === identificationOptions[6].value
        ) {
          // required.push("attachment.data");
        } else {
          validationFields.push(identity);
        }
      }

      if (props.dpType === "CDSL") validationFields.splice(7, 1);

      validationFields.map((x: any) => {
        if (x.split(".").length > 1) {
          let value = getNestedValue(x, nominee);
          if (addressErr(value, x.split(".")[1])) {
            // console.log("111111111111111", x.split(".")[1]);

            let err1 = x
              .split(".")
              .reduceRight(
                (obj: any, key: any) => ({ [key]: obj }),
                addressErr(value, x.split(".")[1])
              );
            // console.log("err1", err1);

            err = {
              ...err,
              [x.split(".")[0]]: {
                ...err[x.split(".")[0]],
                ...err1[x.split(".")[0]],
              },
            };

            validation = false;
          }
        } else err[x] = validateForm(nominee[x], x);
        const child: any = childRef?.current;

        // console.log("x", x, child && child.hasError(nominee[x]));

        if (identity && identity === x && child && child.hasError(nominee[x])) {
          validation = false;
          err[identity] = child.hasError(nominee[x]);
        }

        if (err[x]) validation = false;
      });
      // console.log("sssssssss", obj);

      required.map((x: any) => {
        if (x.split(".").length > 1) {
          if (x === "attachment.data") {
            // console.log("x", x);

            let value = getNestedValue(x, nominee);
            if (value === "" || value === null || value === undefined) {
              let err1 = x
                .split(".")
                .reduceRight(
                  (obj: any, key: any) => ({ [key]: obj }),
                  `This field is required`
                );
              err = {
                ...err,
                [x.split(".")[0]]: {
                  ...err[x.split(".")[0]],
                  ...err1[x.split(".")[0]],
                },
              };
              validation = false;
            }
          }
        } else {
          // if (x === "attachment") {
          //   nominee[x] = nominee[x]?.data;
          //   console.log(nominee[x]);
          // }
          if (x === "nomPer") {
            let totalPercent = handleNomineeShares();
            
            err[x] = validateForm(nominee[x], "nomPer");
            if (!err[x]) {
              if (!totalPercent) {
                err[x] = "Nominee shares is required";
                validation = false;
              } else if (totalPercent !== 100) {
                err[x] = "Total number of shares should be 100%";
                validation = false;
              }
            } else validation = false;
          }
          // if (
          //   nominee[x] === "" ||
          //   nominee[x] === null ||
          //   nominee[x] === undefined
          // ) {
          //   // err[x] = `This field is required`;
          //   validation = false;
          // }
        }
      });
      console.log("err", err);

      setNomineeErr({ ...nomineeErr, ...err });
      return validation;
    },
  }));
  useEffect(() => {
    // console.log({ nomineeErr });
    // console.log({ nominee });

    if (
      Object.values(nomineeErr)
        .map((x) => {
          if (x && typeof x === "object") {
            return Object.values(x)
              .map((z) => z === "" || z === null || z === undefined)
              .every((z) => z === true);
          } else {
            return x === "" || x === null || x === undefined;
          }
        })
        .every((x) => x === true)
    ) {
      props.enableSubmit(true);
    } else {
      props.enableSubmit(false);
    }
  }, [nomineeErr]);

  useEffect(() => {
    if (nominee.firstName) {
      let eqAccName = getAccData("accs").eqAccName;
      var clientName = [nominee.firstName.trim()];
      if(!!nominee.middleName && nominee.middleName !=" ")
        clientName.push(nominee.middleName.trim());
      if(!!nominee.lastName)
        clientName.push(nominee.lastName.trim());
      if (
        eqAccName.toLowerCase() === clientName.join(" ").toLowerCase().trim()
      ) {
        setNomineeErr({
          ...nomineeErr,
          name: "Nominee Name and Guaurdian Name can not be same as Client Name.",
        });
      } else {
        setNomineeErr({
          ...nomineeErr,
          name: "",
        });
      }
    }
  }, [nominee]);
  useEffect(()=>{
    var guardName = "";
    var sameNomName = "";
    if(props.nominee[props.id].minor && props.nominee[props.id].firstName && props.nominee[props.id].guard.firstName){
      let nomName = [props.nominee[props.id].firstName.trim()];
      if(!!props.nominee[props.id].middleName)
        nomName.push(props.nominee[props.id].middleName.trim());
      if(!!props.nominee[props.id].lastName)
        nomName.push(props.nominee[props.id].lastName.trim());
      let GName = [props.nominee[props.id].guard.firstName.trim()];
      if(!!props.nominee[props.id].guard.middleName)
        GName.push(props.nominee[props.id].guard.middleName.trim());
      if(!!props.nominee[props.id].guard.lastName)
        GName.push(props.nominee[props.id].guard.lastName.trim());
      var guardName = "";
      if (nomName.join(" ").toLowerCase() === GName.join(" ").toLowerCase()) {
        guardName = "Nominee Name and Guaurdian Name can not be same";
      } else {
        guardName = "";
      }
    } else if( props.nominee[props.id].minor == false ){
      guardName = "";
    }
    if (props.nominee.length > 1 && props.nominee[0].firstName && props.nominee[1].firstName) {
      const nomineeNames = props.nominee.map((nominee: any) => {
        let fullName = [nominee.firstName.trim()];
        if (nominee.middleName) fullName.push(nominee.middleName.trim());
        if (nominee.lastName) fullName.push(nominee.lastName.trim());
        return fullName.join(" ").toLowerCase();
      });
      let duplicateIndexes: number[] = [];
      var hasDuplicate = false;
      nomineeNames.some((name: any, index: any) => {
        const firstIndex = nomineeNames.indexOf(name);
        if (firstIndex !== index) {
            duplicateIndexes.push(index);
            duplicateIndexes.push(firstIndex);
            hasDuplicate = true;
        }
      });
      if (hasDuplicate && duplicateIndexes.length > 0 && duplicateIndexes.includes(props.id)) {
        sameNomName = "Same nominee is not allowed. Kindly provide a unique nominee for the nomination.";
      } else {
        sameNomName = "";
      }
    }
    setNomineeErr({
      ...nomineeErr,
      guarName: guardName,
      sameName: sameNomName
    });
  }, [props.nominee])
  function signaturePOPUp(): React.ReactElement {
    return (
      <div className="modal-dialog modal-dialog-centered common-modal-deisgn finalPopup consent_popup innerModal ">
        <div className="modal-content">
          <div className="modal-body scrollableModal" id="custom_scrollBar">
            <div>
              <a
                role="button"
                onClick={() => {
                  setViewSampleImage(false);
                }}
                title="Close"
                className="cancel sign-cross-button"
              >
                <i className="edel-icon-close"></i>
              </a>
            </div>
            <div className="finalScreen consentPopup pinError">
              <img src={sampleSignature} height="350px" width="100%" />
            </div>
          </div>
        </div>
      </div>
    );
  }
  function wrongPinCodeMessagePOPUp(): React.ReactElement {
    return (
      <div className="modal-dialog modal-dialog-centered common-modal-deisgn finalPopup consent_popup innerModal ">
        <div className="modal-content">
          <div className="modal-body scrollableModal" id="custom_scrollBar">
            <div className="finalScreen consentPopup pinError">
              <div className="inProgress_wrap">
                <div className=" icon-wrap icon_wrap_red">
                  <i className="edel-icon-exclamation"></i>
                </div>
              </div>
              <div>
                <p className="field-head text-center">
                  This Pincode is not identifiable
                </p>
              </div>
              <div>
                <p className="field-subHead desc text-center subTextHead">
                  Please contact your RM or write to us at
                </p>
                <p className="text-center">
                  <a
                    href="mailto:helpdesk@nuvama.com"
                    className="mail_link"
                  >
                    helpdesk@nuvama.com
                  </a>
                </p>
              </div>
              <div className="display-flex btn_links">
                <div>
                  <button
                    className="ed_button button submit_btn "
                    onClick={(e) => {
                      e.preventDefault();
                      setShowPincodeErrorModel(false);
                    }}
                  >
                    Search Another
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  return (
    <>
      {type && (
        <div
          className={`${type.name}Details${
            type.name === "Guardian" ? " space-mt-3" : ""
          }`}
        >
          <div>
            <h6>
              {type.name} {props.id + 1}
            </h6>
          </div>
          <div className="nomineeGuardianForm">
            <div className="custom--row nomineeShare tradingAccnt nomineeNamefeilds">
              <div className="custom-col-100 noLeftPAdding">
                <label className="input-label">{type.name} Name</label>
                <div className="phone">
                  <div className="firstBlock">
                    <div className="code name">
                      <TocDropdown
                        selectedValue={
                          nominee.title
                            ? nominee.title === "Mr" || nominee.title === "Dr"
                              ? nominee.title + "."
                              : nominee.title
                            : Titles[0].value
                        }
                        dropdownOptions={Titles}
                        onSelect={(title) => {
                          onChange({ title });
                        }}
                        isSearchable={false}
                      />
                    </div>
                    {nomineeErr.title !== "" &&
                      nomineeErr.title !== undefined && (
                        <p className="help_text red">Required</p>
                      )}
                  </div>

                  <InputField
                    pattern={alphabetExp}
                    type="text"
                    required
                    getValue
                    onChange={(firstName) => onChange({ firstName })}
                    onBlur={(error) => {
                      let err = validateForm(error.value, "firstName");
                      setNomineeErr({
                        ...nomineeErr,
                        firstName: err,
                      });
                    }}
                    placeholder="First Name"
                    onMouseOut={() => {}}
                    defaultValue={nominee.firstName}
                    errorText={nomineeErr.firstName}
                    autoComplete="off"
                  />
                  <InputField
                    pattern={alphabetExp}
                    type="text"
                    //  required
                    getValue
                    onChange={(middleName) => onChange({ middleName })}
                    onBlur={(error) => {
                      let err = validateForm(error.value, "middleName");
                      setNomineeErr({
                        ...nomineeErr,
                        middleName: err,
                      });
                    }}
                    placeholder="Middle Name"
                    onMouseOut={() => {}}
                    defaultValue={nominee.middleName}
                    errorText={nomineeErr.middleName}
                    autoComplete="off"
                  />
                  <InputField
                    pattern={alphabetExp}
                    type="text"
                    // required
                    getValue
                    onChange={(lastName) => onChange({ lastName })}
                    onBlur={(error) => {
                      let err = validateForm(error.value, "lastName");
                      setNomineeErr({
                        ...nomineeErr,
                        lastName: err,
                      });
                      // let lastName = "";
                      // if (error.required) lastName = "Last Name is required";
                      // if (error.value.length > 0 && error.value.length < 3)
                      //   lastName = "Min 3 Character Required";
                      // if (!error.pattern)
                      //   lastName = "Only alphabets is allowed";

                      // setNomineeErr({
                      //   ...nomineeErr,
                      //   lastName,
                      // });
                    }}
                    placeholder="Last Name"
                    onMouseOut={() => {}}
                    defaultValue={nominee.lastName}
                    errorText={nomineeErr.lastName}
                    autoComplete="off"
                  />
                </div>
                {nomineeErr.sameName !== "" && nomineeErr.sameName !== undefined && type.name != "Guardian" &&(
                  <p className="help_text red">{nomineeErr.sameName}</p>
                )}
                {nomineeErr.name !== "" && nomineeErr.name !== undefined && (
                  <p className="help_text red">{nomineeErr.name}</p>
                )}
                {nomineeErr.guarName !== "" && nomineeErr.guarName !== undefined && (
                  <p className="help_text red">{nomineeErr.guarName}</p>
                )}
              </div>
            </div>
            <div className="custom--row nomineeShare tradingAccnt">
              <div className="form-field custom-col noLeftPAdding">
                <div>
                  <label className="input-label">
                    Nominee Relationship with{" "}
                    {type.id === 1 ? "Applicant" : "Guardian"}
                  </label>
                  <TocDropdown
                    selectedValue={
                      nominee.nomRel
                        ? nominee.nomRel
                        : applicantRelationships[0].value
                    }
                    dropdownOptions={applicantRelationships}
                    onSelect={(nomRel) => {
                      onChange({ nomRel });
                    }}
                    isSearchable={false}
                  />
                </div>
                {nomineeErr.nomRel !== "" &&
                  nomineeErr.nomRel !== undefined && (
                    <p className="help_text red">{nomineeErr.nomRel}</p>
                  )}
              </div>
              {type && type.id === 1 && (
                <div className="form-field custom-col noLeftPAdding">
                  <label className="input-label">
                    Nominee Percentage of Shares
                  </label>
                  <InputField
                    integer={true}
                    required
                    getValue
                    maxLength={3}
                    onChange={(nomPer) => onChange({ nomPer })}
                    onBlur={(error) => {
                      let err = validateForm(error.value, "nomPer");
                      //  let totalPercent = handleNomineeShares(error.value);
                      // let nomPer = "";
                      // if (error.required) nomPer = "Nominee shares is required";
                      // // if (error.value.length > 0 && totalPercent !== 100)
                      // //   nomPer =
                      // //     "Total of % of shares should not be greater than 100%";
                      setNomineeErr({
                        ...nomineeErr,
                        nomPer: err,
                      });
                    }}
                    onMouseOut={(val) => {}}
                    placeholder="Enter percentage of shares"
                    errorText={nomineeErr.nomPer}
                    defaultValue={nominee.nomPer}
                    autoComplete="off"
                  ></InputField>
                  {/* <p className="error"></p> */}
                </div>
              )}
            </div>
            <div
              className={`custom--row ${type.name}Share tradingAccnt dobNominee`}
            >
              <div className="form-field custom-col noLeftPAdding">
                <label className="input-label">{type.name} Date of Birth</label>
                {/* <Calendar onChange={onChange} value={new Date()} /> */}
                <DatePicker
                  placeholderText="DD/MM/YY"
                  showMonthDropdown
                  showYearDropdown
                  dateFormat="dd/MM/yyyy"
                  dropdownMode="select"
                  selected={
                    nominee.birthdate ? new Date(nominee.birthdate) : null
                  }
                  onKeyDown={(e) => {
                    e.preventDefault();
                  }}
                  onChange={(date) => {
                    const date1 = moment(date, "DD-MMM-YYYY");
                    if (date1.isValid()) {
                      onChange({
                        birthdate: moment(date).format("DD-MMM-YYYY"),
                      });
                      setNomineeErr({ ...nomineeErr, birthdate: "" });
                    }
                  }}
                  onBlur={(e) => {
                    const date = moment(e.target.value, "DD-MMM-YYYY");
                    if (!date.isValid()) {
                      setNomineeErr({
                        ...nomineeErr,
                        birthdate: "Please Enter valid Date format.",
                      });
                    } else {
                      setNomineeErr({
                        ...nomineeErr,
                        birthdate: "",
                      });
                    }
                  }}
                  minDate={
                    moment().subtract(150, "years").toDate()
                  }
                  maxDate={
                    type.id === 1
                      ? new Date()
                      : moment().subtract(18, "years").toDate()
                  }
                />
                {nomineeErr.birthdate !== "" &&
                  nomineeErr.birthdate !== undefined && (
                    <p className="help_text red">{nomineeErr.birthdate}</p>
                  )}
              </div>
            </div>
            <Address
              type={type}
              onChange={onChange}
              nominee={nominee}
              nomineeErr={nomineeErr}
              areaOptions={areaOptions}
              setNomineeErr={setNomineeErr}
              setShowPincodeErrorModel={setShowPincodeErrorModel}
              setLoader={props.setLoader}
              dpType={props.dpType}
            />
            <div className="optional">
              <div className="optional-btn-wrap display-flex space-between-aligned">
                <div className="button">
                  <button type="button" onClick={() => setShowOptional(true)}>
                    <i className="edel-icon-dots-three-horizontal dotIcon"></i>
                    <span>
                      Optional
                      {!showOptional && (nominee?.email || nominee?.phone)
                        ? " (Please click to check data)"
                        : ""}
                    </span>
                  </button>
                </div>
                {showOptional && (
                  <div>
                    <i
                      className="edel-icon-close"
                      onClick={() => {
                        onChange({
                          email: nominee.email ? nominee.email : "",
                          phone: nominee.phone ? nominee.phone : "",
                          pan: "",
                          dpId: "",
                          idTyp: "",
                          attachment: {},
                        });
                        setIdentity("");
                        setShowOptional(false);
                      }}
                    ></i>
                  </div>
                )}
              </div>

              {showOptional && (
                <div className="optional-fields">
                  <div
                    className={`custom--row ${type.name}DetailsContact tradingAccnt`}
                  >
                    <div className="form-field custom-col noLeftPAdding">
                      <label className="input-label">
                        {type.name} Email ID
                      </label>
                      <InputField
                        pattern={emailRegex}
                        getValue
                        onChange={(email) => onChange({ email })}
                        onBlur={(error) => {
                          let err = validateForm(error.value, "email");
                          setNomineeErr({
                            ...nomineeErr,
                            email: err,
                          });
                        }}
                        onMouseOut={() => {}}
                        placeholder="Enter email id"
                        errorText={nomineeErr.email}
                        defaultValue={nominee.email}
                        autoComplete="off"
                      ></InputField>
                    </div>
                    <div className="form-field custom-col noLeftPAdding">
                      <label className="input-label">
                        {type.name} Mobile Number
                      </label>
                      <InputField
                        pattern={phoneNo}
                        integer={true}
                        maxLength={10}
                        getValue
                        onChange={(phone) => onChange({ phone })}
                        onBlur={(error) => {
                          let err = validateForm(error.value, "phone");
                          setNomineeErr({
                            ...nomineeErr,
                            phone: err,
                          });
                        }}
                        onMouseOut={() => {}}
                        placeholder="Enter mobile number"
                        errorText={nomineeErr.phone}
                        defaultValue={nominee.phone}
                        autoComplete="off"
                      ></InputField>
                    </div>
                  </div>
                  <IdentifDet
                    type={type}
                    id={props.id}
                    onChange={onChange}
                    nominee={nominee}
                    setNomineeErr={setNomineeErr}
                    nomineeErr={nomineeErr}
                    accountCode={props.accountCode}
                    setLoader={props.setLoader}
                    updateIdentity={setIdentity}
                    userPan={props.userPan}
                    ref={childRef}
                    setViewSampleImage={setViewSampleImage}
                  ></IdentifDet>
                </div>
              )}
            </div>

            {type.id === 1 &&
              props.id > 0 &&
              nominee.minor &&
              props.isGuardianAvailable && (
                <div className="display-flex declarationWrap">
                  <Checkbox
                    checked={nominee.sameas}
                    name="consent"
                    onChange={(value) => {
                      let sameas = props.nominee[Number(props.id)].sameas
                        ? false
                        : true;
                      onChange({ sameas }, "sameAs");
                      props.setSameGuardian(!props.sameGuardian);
                    }}
                  ></Checkbox>
                  <span className="incomeMsg regular-font declare">
                    Guardian Details Same as above{" "}
                  </span>
                </div>
              )}
          </div>
        </div>
      )}
      <EdModal
        show={showPincodeErrorModel}
        close={() => {}}
        children={wrongPinCodeMessagePOPUp()}
        // modalClsNm={"absoluteModal"}
      />
      <EdModal
        show={viewSampleImage}
        close={() => {}}
        children={signaturePOPUp()}
        // modalClsNm={"absoluteModal"}
      />
    </>
  );
});
